
/** Enumeratin of all service status providers. */
export enum ServiceStatusProviderType {
  MessagingService = 'MessagingService',
  VideoService = 'VideoService',
}
